import React from "react";
import "./index.css";
import ayanPic from "../../../assets/images/ayan.png";
import { FeatureCoursesWraper } from "../../../component";
import allRoute from "../../../utils/constants";

export default function Whoisbehind2() {
  return (
    <div className="WhoIsBehind2">
      <div style={{ zIndex: 1 }}>
        <p className="whoisbehind2-eyebrow">WHO’S BEHIND</p>
        <p className="whoisbehind2-title">Meet the instructors</p>
      </div>

      <div className="AboutUs1">
        <FeatureCoursesWraper
          data_aos="fade-right"
          pic={ayanPic}
          isinstructor={true}
          colors={"#FFB84F"}
          data={allRoute.react}
          Heading={"React Tutorials"}
          Discription={"Master React, a JavaScript library for building user interfaces."}
        />
        <FeatureCoursesWraper
          data_aos="fade-left"
          pic={ayanPic}
          isinstructor={true}
          colors={"#E33830"}
          reverse={"row-reverse"}
          data={allRoute.firebase}
          Heading={"Firebase Tutorials"}
          Discription={"Harness the power of Firebase for developing web and mobile applications."}
        />
      </div>
    </div>
  );
}
